import React from "react";
import { Tooltip } from "./Tooltip";
import { HeaderConfig, appliedConfig } from "../config/commonConfig";

const Footer = () => {
  return (
    <footer
      id="footer"
      className={
        "section  " +
        (appliedConfig.appliedHeader === HeaderConfig.SideHeaderDark ||
        appliedConfig.appliedHeader === HeaderConfig.SideHeaderLight
          ? "px-lg-4 "
          : "bg-dark footer-text-light ")
      }
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-5 align-self-center text-center text-lg-start">
            <p className="mb-0">
              © {new Date().getFullYear()}{" "}
              <a
                href="/"
                className="link-underline link-underline-opacity-0-hover"
              >
                EAD Rio Branco
              </a>
              - Todos os direitos reservados
            </p>
          </div>
          <div className="col-lg-2 align-self-center justify-content-center justify-content-lg-start">
            <ul className="social-icons social-icons-lg social-icons-muted justify-content-center py-3 py-lg-0">
              <Tooltip text="Facebook" placement="top">
                <li className="social-icons-verde">
                  <a
                    data-bs-toggle="tooltip"
                    href="https://www.facebook.com/eadcursosdetransito"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-facebook-f" />
                  </a>
                </li>
              </Tooltip>
              <Tooltip text="Instagram" placement="top">
                <li className="social-icons-verde">
                  <a
                    data-bs-toggle="tooltip"
                    href="https://www.instagram.com/cursosdetransitoriobranco/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-instagram" />
                  </a>
                </li>
              </Tooltip>
              <Tooltip text="Linkedin" placement="top">
                <li className="social-icons-verde">
                  <a
                    data-bs-toggle="tooltip"
                    href="https://www.linkedin.com/company/ead-rio-branco-cursos-de-tr%C3%A2nsito/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-linkedin-in" />
                  </a>
                </li>
              </Tooltip>
              <Tooltip text="Google+" placement="top">
                <li className="social-icons-verde">
                  <a
                    data-bs-toggle="tooltip"
                    href="https://share.google/RxY3jLwUgKUDjr2c1"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-google-plus-g" />
                  </a>
                </li>
              </Tooltip>
            </ul>
          </div>
          <div className="col-lg-5 align-self-center">
            <ul className="nav nav-separator nav-separator-light justify-content-center justify-content-lg-end">
              <li className="nav-item">
                {" "}
                <a
                  className="nav-link"
                  data-bs-toggle="modal"
                  data-bs-target="#terms"
                  href="/"
                >
                  Termos de Uso
                </a>
              </li>
              <li className="nav-item">
                {" "}
                <a
                  className="nav-link"
                  data-bs-toggle="modal"
                  data-bs-target="#privacy"
                  href="/"
                >
                  Política de Privacidade
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
